import { render, staticRenderFns } from "./InvoiceTabIssuedOther.vue?vue&type=template&id=f568f06c"
import script from "./InvoiceTabIssuedOther.vue?vue&type=script&lang=js"
export * from "./InvoiceTabIssuedOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f568f06c')) {
      api.createRecord('f568f06c', component.options)
    } else {
      api.reload('f568f06c', component.options)
    }
    module.hot.accept("./InvoiceTabIssuedOther.vue?vue&type=template&id=f568f06c", function () {
      api.rerender('f568f06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sinvoice_viettel/invoice-management-other/tabs/InvoiceTabIssuedOther.vue"
export default component.exports